/* AFATO 5.2: Set-Empfehlung im Warenkorb - ein Klick mit vorbelegter Groesse, keine Schnellansicht mehr.
   1. Wenn der Size Finder auf der Produktseite eine Groesse berechnet hat (localStorage afatoSizeReco)
      und diese Groesse verfuegbar ist, wird sie im Empfehlungs-Button gesetzt und beschriftet.
   2. Sonst bleibt die serverseitig gesetzte Groesse aus dem Warenkorb stehen.
   Ausserdem: Ziel des Add-to-Cart hart auf <cart-drawer>, damit nie die kleine Benachrichtigung kommt,
   und die Beschriftung des Checkout-Buttons. Letztere steht in locales/de.json (deutsch ist die
   Hauptsprache des Shops, also nicht als Uebersetzung ueberschreibbar) - die 21 KB grosse Sprachdatei
   fuer ein Wort neu zu schreiben waere unnoetig riskant, deshalb wird das Label hier gesetzt. */
(function () {
  if (window.__afatoRecInit) return;
  window.__afatoRecInit = true;

  function isDe() { return (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0; }

  function applyRecoSize(pf) {
    if (!pf || pf.getAttribute('data-size-source') === 'calculator') return;
    var reco;
    try { reco = localStorage.getItem('afatoSizeReco'); } catch (e) { return; }
    if (!reco) return;
    reco = reco.trim().toUpperCase();
    var map;
    try { map = JSON.parse(pf.getAttribute('data-sizes') || '{}'); } catch (e) { return; }
    var entry = map[reco];
    if (!entry || !entry.a) return;
    var vid = pf.querySelector('.afato-rec__vid');
    var txt = pf.querySelector('.afato-rec__addtext');
    if (vid) vid.value = entry.i;
    if (txt && txt.getAttribute('data-tpl')) txt.textContent = txt.getAttribute('data-tpl').replace('%s', reco);
    pf.setAttribute('data-size-source', 'calculator');
  }

  /* Dawns product-form bevorzugt von sich aus <cart-notification>. Eine eigene Property auf der
     Instanz schlaegt sowohl den Getter als auch die im Konstruktor gesetzte Variante. */
  function forceDrawer(pf) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !pf) return;
    try { Object.defineProperty(pf, 'cart', { value: drawer, writable: true, configurable: true }); } catch (e) {}
  }

  function setCheckoutLabel() {
    if (!isDe()) return;
    var btns = document.querySelectorAll('.cart__checkout-button');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.getAttribute('data-afato-label') === '1') continue;
      b.textContent = 'ZUR KASSE →';
      b.setAttribute('data-afato-label', '1');
    }
  }

  function init() {
    setCheckoutLabel();
    var pf = document.querySelector('.afato-rec .afato-rec__pf');
    if (!pf) return;
    applyRecoSize(pf);
    forceDrawer(pf);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Der Drawer wird bei jeder Warenkorb-Aenderung per innerHTML neu aufgebaut - danach erneut anwenden. */
  var drawerEl = document.getElementById('CartDrawer');
  if (drawerEl) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(init, 50);
    }).observe(drawerEl, { childList: true, subtree: true });
  }
})();

/* AFATO: PDP-Size-Finder – Groessentabellen-Bild tauschen (howtomeasure), aufgelegte Messlinien/Labels ausblenden,
   E-Mail-Icon-Kreis auf ausverkauften Groessen weiss (Gruen 2.0: vorher #456689). */
(function () {
  var IMG = 'https://cdn.shopify.com/s/files/1/0778/3789/3961/files/howtomeasure_Kopie-01_a82a201d-0c48-4903-b275-072026df97af.jpg?v=1703267322';
  var st = document.createElement('style');
  st.textContent =
    '.afsf-mimg .afsf-dline, .afsf-mimg .afsf-lbl { display: none !important; } ' +
    ".product-form__input--pill input[type='radio'].disabled + label::after, .product-form__input--pill input[type='radio']:disabled + label::after, [class*='rio-swatch-unavailable-']::before { background-color: #ffffff !important; }";
  (document.head || document.documentElement).appendChild(st);
  function swap() {
    var i = document.getElementById('afsfSgImg');
    if (i && i.getAttribute('src').indexOf('howtomeasure_Kopie-01') === -1) i.setAttribute('src', IMG);
  }
  if (document.readyState !== 'loading') swap();
  else document.addEventListener('DOMContentLoaded', swap);
})();